import { render, staticRenderFns } from "./HomeworkPlaningWidget.vue?vue&type=template&id=4b283526"
import script from "./HomeworkPlaningWidget.vue?vue&type=script&lang=js"
export * from "./HomeworkPlaningWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b283526')) {
      api.createRecord('4b283526', component.options)
    } else {
      api.reload('4b283526', component.options)
    }
    module.hot.accept("./HomeworkPlaningWidget.vue?vue&type=template&id=4b283526", function () {
      api.rerender('4b283526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/dashboard_widgets/HomeworkPlaningWidget.vue"
export default component.exports